var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"m-button",class:{
    'm-button_disabled': _vm.disabled,
    'm-button_light': _vm.light,
    'm-button_critical': _vm.critical,
    'm-button_gray': _vm.gray,
    'm-button_secondary': _vm.secondary,
    'm-button_link': _vm.link,
    'm-button_small': _vm.small,
    'm-button_large': _vm.large,
    'm-button_loading': _vm.isLoading
  },attrs:{"title":_vm.title},on:{"click":_vm.handleClick}},[(_vm.isLoading)?_c('SmallSpinner',{staticClass:"m-button__spinner",attrs:{"radius":5.5,"stroke-width":1.5}}):_vm._e(),_vm._v(" "),(Boolean(_vm.icon) && !_vm.iconOnTheRight)?_c('MIcon',{staticClass:"m-button__icon",class:{'m-button__icon_large': _vm.large},attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"m-button__text"},[_vm._t("default")],2),_vm._v(" "),(Boolean(_vm.icon) && _vm.iconOnTheRight)?_c('MIcon',{staticClass:"m-button__icon m-button__icon_right",attrs:{"icon":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }